module.exports = __webpack_public_path__ + "assets/img/30@3x.ee5adbc5.png";